import React, { useCallback, useRef } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import { SmartCaptcha } from 'components/atoms';

const SMARTCAPTCHA_CLIENT_KEY = process.env.REACT_APP_SMARTCAPTCHA_CLIENT_KEY || '';

export interface CaptchaModalProps {
  visible: boolean;
  onToken: (token: string) => void;
  onCancel: () => void;
}

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 24px;
  }
`;

export const CaptchaModal: React.FC<CaptchaModalProps> = (props: CaptchaModalProps) => {
  const { visible, onToken, onCancel } = props;
  const [captchaKey, setCaptchaKey] = React.useState(0);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  const handleToken = useCallback((token: string) => {
    onTokenRef.current(token);
  }, []);

  React.useEffect(() => {
    if (visible) {
      setCaptchaKey((k: number) => k + 1);
    }
  }, [visible]);

  if (!SMARTCAPTCHA_CLIENT_KEY) {
    return null;
  }

  return (
    <StyledModal
      title="Подтвердите, что вы не робот"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={400}
      centered
      forceRender
      destroyOnClose={false}
      maskClosable={false}
      keyboard={false}
      focusTriggerAfterClose={false}
      afterClose={() => {
        setCaptchaKey((k: number) => k + 1);
      }}
    >
      <SmartCaptcha key={captchaKey} siteKey={SMARTCAPTCHA_CLIENT_KEY} onSuccess={handleToken} />
    </StyledModal>
  );
};
